<template>
  <div>
    <v-divider></v-divider>
    <div class="mt-2">
      <span v-html="invoice.merchandise_invoice_text"></span>
    </div>

    <table class="invoice-table invoice-payment-details">
      <tr>
        <th class="invoice-table__header invoice-table--align-left">
          Description
        </th>
        <th v-if="isFormTypeNormal"
            class="invoice-table__header invoice-table--align-left">
          Brand
        </th>
        <template v-else-if="isFormTypeAdditional">
          <th class="invoice-table__header invoice-table--align-left">
            Item size
          </th>
          <th class="invoice-table__header invoice-table--align-left">
            item color
          </th>
        </template>
        <th class="invoice-table__header invoice-table--align-left">
          Price
        </th>
        <th class="invoice-table__header invoice-table--align-left">
          Quantity
        </th>
        <th class="invoice-table__header invoice-table--align-right invoice-table__cell--amount">
          Amount
        </th>
      </tr>
      <tr v-for="product in invoice.order.products" :key="product.id">
        <td class="invoice-table__cell invoice-table--align-left">
          {{product.description}}
        </td>
        <td v-if="isFormTypeNormal"
            class="invoice-table__cell invoice-table--align-left">
          {{product.brand}}
        </td>
        <template v-else-if="isFormTypeAdditional">
          <td
              class="invoice-table__cell invoice-table--align-left">
            {{product.item_size}}
          </td>
          <td class="invoice-table__cell invoice-table--align-left">
            {{product.item_color}}
          </td>
        </template>
        <td class="invoice-table__cell invoice-table--align-left">
          {{ currencySymbol }}{{product.price}}
        </td>
        <td class="invoice-table__cell invoice-table--align-left">
          {{product.quantity}}
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{product.quantity * product.price}}
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan - 1">
          Dimensions
        </td>
        <td class="invoice-table__cell invoice-table--align-right">
          {{ invoice.order.length || 0 }} x {{ invoice.order.height || 0 }} x {{ invoice.order.width || 0 }} <span v-html="invoice.dimension_metrics || ''"></span>
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan - 1">
          Weight
        </td>
        <td class="invoice-table__cell invoice-table--align-right">
          {{ invoice.order.package_weight | kg }}
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          Sales Tax
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{invoice.tax_amount.toFixed(2)}}
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          Site shipping
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{invoice.shipping_amount.toFixed(2)}}
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          Hotel4Box shipping
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{invoice.duty_amount.toFixed(2)}}
        </td>
      </tr>
      <tr v-for="(charge, index) in invoice.custom_charges" :key="index">
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          {{charge.custom_charge.description}}
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{charge.amount}}
        </td>
      </tr>
      <tr v-if="invoice.use_insurance">
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          Insurance amount
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{ invoice.insurance }}
        </td>
      </tr>
      <tr v-if="invoice.reduce_by_points">
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          Reduce by points
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          -{{ currencySymbol }}{{invoice.reduce_by_points}}
        </td>
      </tr>
      <tr v-if="invoice.discount_amount">
        <td class="invoice-table__cell invoice-table--align-left"
            :colspan="formTypeColspan">
          {{ invoice.discount_description || 'Discount' }}
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          - {{ currencySymbol }}{{invoice.discount_amount}}
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-right"
            :colspan="formTypeColspan">
          Items total
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount">
          {{ currencySymbol }}{{invoice.total_products.toFixed(2)}}
        </td>
      </tr>
      <tr>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--total"
            :colspan="formTypeColspan">
          Total (if paid to US bank):
        </td>
        <td
            class="invoice-table__cell invoice-table--align-right invoice-table__cell--amount invoice-table__cell--total">
          {{ currencySymbol }}{{invoice.amount_total}}
        </td>
      </tr>
      <tr v-for="(item, index) in invoice.amountInOtherCurrencies" :key="index + 'currency'">
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--total"
            :colspan="formTypeColspan">
          Total (if paid to Mongolian bank):
        </td>
        <td class="invoice-table__cell invoice-table--align-right invoice-table__cell--total">
          {{ item.symbol }}{{ item.amount }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  name: 'MerchandiseViewBody',
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    currencySymbol() {
      if (
          (this.invoice.order === undefined && this.invoice.group === undefined) ||
          (this.invoice.order.id === 0 && this.invoice.group === null)
      ) {
        return '$'
      } else {
        if (this.invoice.order) {
          return this.invoice.order.currency.symbol;
        } else {
          return this.invoice.group.orders[0].currency.symbol;
        }
      }
    },
    isFormTypeNormal() {
      return this.invoice.order.form_type === this.$formType.normal;
    },
    isFormTypeAdditional() {
      return this.invoice.order.form_type === this.$formType.additional;
    },
    formTypeColspan() {
      if (this.isFormTypeNormal) {
        return 4;
      } else if (this.isFormTypeAdditional) {
        return 5;
      }
    },
  },
  filters: {
    kg: (weight) => weight + ' kg.',
  },
}
</script>

<style scoped lang="stylus">

td
  background-color #fff
  border none
  padding 0

th
  background-color #fff
  border none

.invoice-table
  border-spacing 0
  margin 0.5em
  width 100%

.invoice-table--align-left
  text-align left

.invoice-table--align-right
  text-align right

.invoice-table__header
  border-top 2px solid #ddd
  border-bottom 2px solid #ddd
  padding 0.8em 0.5em

.invoice-table__cell
  padding 0.5em
  border-bottom 1px solid #ddd

.invoice-table__cell--amount
  width 15%

.invoice-table__cell--total
  font-weight bold
  border-bottom 0
  margin-bottom 1em

.invoice-merchandise-terms
  margin 1em

.invoice-merchandise-terms ol
  padding 0

.invoice-merchandise-terms p
  margin 0.5em

.invoice-merchandise-terms ol li
  list-style decimal inside
  margin 0.5em

</style>
